'use es6';

import { SELECT_FORM_ITEM, RESET_SELECTED_FORM_ITEM } from 'FormsUI/actions/FormSelection';
const INITIAL_STATE = {
  formItemType: null,
  formItemReference: null
};
export function formSelection(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SELECT_FORM_ITEM:
      return {
        formItemType: action.formItemType,
        formItemReference: action.formItemReference
      };
    case RESET_SELECTED_FORM_ITEM:
      return {};
    default:
      return state;
  }
}